import { useCommonTx } from '~/hooks/useTranslationForNamespace'
import Image1 from '~/images/Landing/spot-A.svg'
import Image2 from '~/images/Landing/spot-B.svg'
import Image3 from '~/images/Landing/spot-C.svg'

export const TrainingSection = () => {
  const t = useCommonTx('landing.trainingSection')

  return (
    <div className='px-8 py-[8%] flex flex-col items-center w-full'>
      <div className='flex flex-col justify-center items-center pt-12 pb-8 w-full max-w-[846px] text-center'>
        <div className='text-title-1 font-bold font-serif mb-4'>{t('header')}</div>
        <div className='text-body-text-2'>{t('body')}</div>
      </div>
      <div className='flex justify-around flex-wrap py-12 gap-y-[64px] gap-x-[32px] w-full max-w-[1058px]'>
        <Column>
          <div>
            <Image1 title='image-1' height={120} width={120} />
          </div>
          <PropHeading>{t('column1Header')}</PropHeading>
          <div className='text-body-text-1'>{t('column1Body')}</div>
        </Column>
        <Column>
          <div>
            <Image2 title='image-2' height={120} width={120} />
          </div>
          <PropHeading>{t('column2Header')}</PropHeading>
          <div className='text-body-text-1'>{t('column2Body')}</div>
        </Column>
        <Column>
          <div>
            <Image3 title='image-3' height={120} width={120} />
          </div>
          <PropHeading>{t('column3Header')}</PropHeading>
          <div className='text-body-text-1'>{t('column3Body')}</div>
        </Column>
      </div>
    </div>
  )
}

const PropHeading = ({ children }: { children: React.ReactNode }) => {
  return <div className='text-heading-3 h-[40px] w-full'>{children}</div>
}

const Column = ({ children }: { children: React.ReactNode }) => {
  return <div className='flex flex-col items-center text-center min-w-[250px] basis-[30%] gap-7'>{children}</div>
}
